import { render, staticRenderFns } from "./ManageAnnouncements.vue?vue&type=template&id=2e1f3aaf&scoped=true"
import script from "./ManageAnnouncements.vue?vue&type=script&lang=js"
export * from "./ManageAnnouncements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1f3aaf",
  null
  
)

export default component.exports